import classNames from 'classnames'

import styles from './ToggleButton.module.scss'

const ToggleButton = ({
  title,
  options = [],
  selectedOption = {},
  handleChange,
  selectedOptionKey,
  disabled,
}) => {
  const handleOptionChange = (e, option) => {
    if (handleChange) {
      handleChange(e, option, selectedOptionKey)
    }
  }

  return (
    <div className={styles.toggleRootContainer}>
      <span className={styles.filterTitle}>{title}</span>
      <div className={styles.toggleContainer}>
        {options.map((option, index) => (
          <Button
            key={option?.value + index}
            button={option}
            disabled={disabled}
            handleOptionChange={handleOptionChange}
            selectedOption={selectedOption}
          />
        ))}
      </div>
    </div>
  )
}

export const Button = ({
  button,
  disabled,
  handleOptionChange,
  selectedOption,
  children,
}) => (
  <button
    aria-label={button?.label}
    className={classNames(styles.toggleOption, {
      [styles.active]: button?.value === selectedOption?.value,
    })}
    onClick={(e) => handleOptionChange(e, button)}
    disabled={disabled}
  >
    {button?.label}
    {children}
  </button>
)

export default ToggleButton
